import indexMixin from "../mixins/index";
export default {
  name: 'res-dropdown',
  mixins: [indexMixin],
  props: {
    options: {
      type: Array,
      default: () => []
    },
    dropdownType: {
      type: String,
      default: 'text'
    },
    buttonName: {
      type: String,
      default: '文字按钮'
    },
    valueKey: {
      type: String,
      default: "command"
    },
    labelKey: {
      type: String,
      default: "label"
    },
    iconKey: {
      type: String,
      default: "icon"
    }
  },

  data() {
    return {};
  },

  methods: {}
};